/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationScheduleResponse {
    getFixupPrototypeFunction() { return ScheduleRecommendationScheduleResponse.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationScheduleResponse>): ScheduleRecommendationScheduleResponse {
        let obj = Object.assign(new ScheduleRecommendationScheduleResponse(), model);
        ScheduleRecommendationScheduleResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationScheduleResponse>): ScheduleRecommendationScheduleResponse {
        if (!model) return null;
        return ScheduleRecommendationScheduleResponse.newInstance(<ScheduleRecommendationScheduleResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationScheduleResponse) {
        if (!obj) return;

        models.ScheduleRecommendationScheduleResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationScheduleResponse): boolean {
        Object.setPrototypeOf(obj, ScheduleRecommendationScheduleResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.overall_savings_percentage === undefined) {
            this.overall_savings_percentage = 0;
        }
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.recommendations) {
            for (let val of this.recommendations) {
                models.ScheduleRecommendationDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Recommendation Details By Account
     */
    recommendations: Array<models.ScheduleRecommendationDetails>;

    /**
     * Overall Savings Percentage
     */
    overall_savings_percentage: number;

    /**
     * Total Count of Resources
     */
    total_count: number;

}
